export default "__VITE_ASSET__CzCK7Nq9__"